import React from "react";

function NotAdminScreen() {
  return <div>NotAdminScreen</div>;
}

export default NotAdminScreen;
